import { render, staticRenderFns } from "./ModalEstagio.vue?vue&type=template&id=b7220542&scoped=true&"
import script from "./ModalEstagio.vue?vue&type=script&lang=js&"
export * from "./ModalEstagio.vue?vue&type=script&lang=js&"
import style0 from "./ModalEstagio.vue?vue&type=style&index=0&id=b7220542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7220542",
  null
  
)

export default component.exports